import { render, staticRenderFns } from "./TenantComponent.vue?vue&type=template&id=1443cc96&scoped=true"
import script from "./TenantComponent.vue?vue&type=script&lang=js"
export * from "./TenantComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443cc96",
  null
  
)

export default component.exports